import React from 'react';
import ServiceDetail from '../ServiceDetail';

// Dedicated page component for /services/bed-bug-removal
const BedBugPage = () => <ServiceDetail slug="bed-bug-removal" />;

export default BedBugPage;
